import editCompleteOrder from '../components/editCompleteOrder.vue'
import orderStatus from '../components/orderStatus.vue'
// import orderSend from '../components/orderSend.vue'
import store from '@/store'
import DeleteOrder from './../components/orderDelete.vue'
// import NP from 'number-precision'
import vue from 'vue'
const that = vue.prototype
export default {
  className: 'Order', // 未发出订单  已完成订单
  title: '未发出订单',
  mixin: {
    fields: [
      {
        // 所属用户
        name: 'userid',
        note: '销售人员',
        width: 80,
        validators: [
          val => (val) ? null : '销售员不可为空'
        ]
      },
      {
        name: 'userCompany',
        note: '销售公司',
        width: 80
      },
      {
        name: 'userid.username',
        width: 110,
        note: '经理电话'
      },
      {
        // 型号
        name: 'finishProductid',
        width: 80,
        validators: [
          val => (val) ? null : '成品型号不可为空'
        ]
      },
      {
        // 麦头
        name: 'markid',
        width: 80,
      },
      {
        // 包装
        name: 'packid',
        width: 80,
      },
      {
        // 托盘
        name: 'palletid',
        width: 80,
      },
      {
        // 状态
        name: 'status',
        width: 100,
        view: {
          component: orderStatus
        }
      },
      {
        // 吨数
        name: 'amount',
        width: 80,
        validators: [
          val => (val) ? null : '吨数不可为空'
        ]
      },
      {
        // 运费
        name: 'shipping',
        width: 80,
      },
      {
        name: 'clientid.name',
        width: 110
      },
      {
        name: 'clientid.phone',
        width: 130
      },
      {
        name: 'clientid.address',
        width: 110
      },
      {
        name: 'clientid.linkman',
        width: 80
      },
      {
        // 下单日期
        name: 'orderDate',

        note: '下单日期'
      },
      {
        // 交付日期
        name: 'shipDate',
      },

      {
        // 备注
        name: 'remarks',
        width: 80
      },
      {
        name: 'updatedAt',
      }

    ],
  },
  search: [
    'userid',
    'userCompany',
    'finishProductid',
    'orderDate',
    'updatedAt'
  ],
  action: {
    create: false,
    edit: store.state.user && store.state.user.authority.completeOrder.edit ? {
      type: 'row',
      text: '编辑',
      component: editCompleteOrder
    } : false,
    post: store.state.user && store.state.user.authority.completeOrder.post ? {
      type: 'row',
      text: '确认发出',
      callback: async ({ record, vm, modelName }) => {
        await vm.confirm('提示', '确认发出此订单？')
        let data = {
          sentAt: '',
          status: 'transit'
        }
        data.sentAt = new Date().toISOString()
        let rs = await vm.$modelAjax.put(modelName, record.objectId, data).catch(() => {
          vm.$notification['error']({
            message: '网络错误',
            description: '订单发出失败'
          })
        })
        if (rs) {
          vm.$notification['success']({
            message: '操作成功',
            description: '订单已发出'
          })
          vm.refresh() // 你可以调用refresh与reset方法来刷新页面，区别为reset会重置查询条件，排序，翻页页数
          if (!(record.isReserve)) {
            that.$tkParse.post('/sendMessage/sendToStaff', { record: record, status: '运输中订单' })
            that.$tkParse.post('/sendMessage/sendToOwner', { record: record, status: '运输中订单' })
          }
        }
      }
      // component: orderSend
    } : false,
    delete: false,
    myDelete: store.state.user && store.state.user.authority.completeOrder.del
      ? {
        type: 'row',
        text: '删除',
        component: DeleteOrder
      }
      : false
  },
  hooks: {
    async beforeFetch ({ where }) {
      if (where && where.userCompany) {
        let res = await that.$tkParse.getData('/classes/_User', {
          params: {
            where: {
              company: where.userCompany
            }
          }
        })
        let target = []
        for (let i in res.results) {
          target.push(res.results[i].objectId)
        }
        delete where.userCompany
        where.userid = { $in: target }
      }
      where.status = 'complete'
      // 查看所有订单
      where.isReserve = { $ne: true }
      if (store.state.user && store.state.user.allShopManagements === 'Yes') {

      } else {
        // where.shopManagementid = {
        //   $in: store.state.user.shopManagements
        // }
        where.finishProductid = {
          $inQuery: {
            where: {
              workShop: {
                $inQuery: {
                  where: {
                    objectId: { $in: store.state.user.shopManagements }
                  },
                  className: 'shopManagement'
                }
              }
            },
            className: 'finishProduct'
          }
        }
      }
      if (store.state.user && store.state.user.allClient === 'Yes') { } else {
        where.userid = store.state.user.objectId
      }
    }
    // beforeUpdate ({ data }) {
    //   data.pricePerTon = NP.round(NP.divide(data.shipping, data.amount))
    // }
  }
}
